import { FormControl } from "@material-ui/core";
import _ from "lodash";
import { Column } from "material-table";
import React, { useCallback } from "react";
import Select from "react-select";
import { useAllClients } from "../../../hooks/useAllClients";
import { useProfile } from "../../../hooks/useProfile";

interface RP<T extends object> {
  columnDef: Column<T>,
  onFilterChanged: (rowId: string, value: any) => void
}

export function SelectFilterComponent<T extends object>(p: RP<T>) {
  const {clients} = useAllClients(),
    {profile} = useProfile()
  // @ts-ignore
  const selected: number = p.columnDef.tableData.filterValue;

  const onChange = useCallback( (val, actionMeta) => {
    // @ts-ignore
    p.onFilterChanged(p.columnDef.tableData.id, (val == null) ? null: _.find(clients, c => c.id === val['value']))
  }, [clients, p])

  if (profile?.role !== 'admin') {
    return <></>
  }
  let options: {}[] = _.map(clients, c => {
      return {
        label: c.name,
        value: c.id
      }
    }
  )

  return <>
    <FormControl fullWidth>
      <Select
        defaultValue={selected}
        options={options}
        isSearchable={true}
        isClearable={true}
        onChange={onChange}
      />
    </FormControl>
  </>
}
